import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";

type AppLocation = {
  city: string;
  country: string;
  countryCode?: string;
  coords: {
    lat: number;
    lng: number;
  };
};

interface Props {
  fetchCurrentLocation?: () => void | Promise<void>;
  setLocation: React.Dispatch<React.SetStateAction<AppLocation>>;
}

const MapInitializer = ({ fetchCurrentLocation, setLocation }: Props) => {
  const map = useMap();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const stored = sessionStorage.getItem("selectedLocation");
    const hasGeoConsent =
      localStorage.getItem("privacy:locationConsent") === "true";

    const tryFetch = async () => {
      if (!fetchCurrentLocation || !hasGeoConsent) return;

      try {
        await fetchCurrentLocation();
      } catch {
        // denied, blocked, or unavailable
      }
    };

    if (stored) {
      try {
        const parsed = JSON.parse(stored);

        if (parsed?.city && parsed?.country) {
          setLocation((prev) => ({
            ...prev,
            city: parsed.city,
            country: parsed.country,
            countryCode: parsed.countryCode,
          }));

          tryFetch();
          return;
        }

        tryFetch();
      } catch (error) {
        console.warn("Error parsing stored location — trying fetch:", error);
        tryFetch();
      }
    } else {
      tryFetch();
    }
  }, [fetchCurrentLocation, setLocation, map]);

  return null;
};

export default MapInitializer;